u.Menu = class extends u.BaseElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
    }

    detachedCallback() {
        /**
         * Cleanup element on detachment
         */
        this.$close();
    }

    $open() {
        /**
         * Open the element
         */

        this.classList.add('open');
    }

    $close() {
        /**
         * Close the element
         */

        this.classList.remove('open');
    }

    $toggle() {
        /**
         * Toggle the element open and close
         */
        if (this.classList.contains('open')) {
            this.$close();
        } else {
            this.$open();
        }
    }
};

u.Menu.register('u-menu');